export default __webpack_public_path__ + "static/media/img9.5c261a59.jpg";